import { LiaRupeeSignSolid } from "react-icons/lia";
import { HeadingTitle, Button } from "../../../components/shared/index";

const CartOrderSummary = ({
  styles,
  subtotal,
  shippingCost,
  tax,
  totalAmount,
  onButtonClick,
    loading,
      selectedCount, 
}) => {
  return (
    <div className={styles.summarySection}>
      <HeadingTitle style={styles.summaryHeading} text="Order Summary" />

    <div className={styles.summaryRow}>
  <div>
    <span>Subtotal</span>
    <div style={{ fontSize: "12px", opacity: 0.7 }}>
      ({selectedCount} item{selectedCount !== 1 ? "s" : ""})
    </div> 
  </div>

  <span>
    <LiaRupeeSignSolid size={20} />
    {subtotal}
  </span>
</div>

      <div className={styles.summaryRow}>
        <span>Shipping</span>
        <span>{shippingCost === 0 ? "Free" : `₹${shippingCost}`}</span>
      </div>

      <div className={styles.summaryRow}>
        <span>Tax</span>
        <span>
          <LiaRupeeSignSolid size={20} /> {tax || 0}
        </span>
      </div>

      <div className={`${styles.summaryRow} ${styles.totalRow}`}>
        <strong>Total</strong>
        <strong>
          <LiaRupeeSignSolid size={20} /> {totalAmount}
        </strong>
      </div>

   <Button
  title={
    loading ? (
      <>
        <span className={styles.spinner}></span>
        Processing...
      </>
    ) : (
      "Proceed To Checkout"
    )
  }
  onHandler={onButtonClick}
  style={styles.checkoutBtn}
  disabled={loading}
/>
    </div>
  );
};

export default CartOrderSummary;
